/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { CreatePayoutDto } from "../types/createPayoutDto";

import type { ListPayablesParams } from "../types/listPayablesParams";

import type { PayPayoutNowDto } from "../types/payPayoutNowDto";

import type { PayPayoutsNowDto } from "../types/payPayoutsNowDto";

import type { PayoutDetailDto } from "../types/payoutDetailDto";

import type { PayoutListItemDtoPaginatedResult } from "../types/payoutListItemDtoPaginatedResult";

import type { PayoutStatsDto } from "../types/payoutStatsDto";

import type { ProblemDetails } from "../types/problemDetails";

import type { VoidPayoutDto } from "../types/voidPayoutDto";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const listPayables = (
  params?: ListPayablesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutListItemDtoPaginatedResult>> => {
  return axios.default.get(`/api/payouts/payables`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListPayablesQueryKey = (params?: ListPayablesParams) => {
  return [`/api/payouts/payables`, ...(params ? [params] : [])] as const;
};

export const getListPayablesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayables>>,
  TError = AxiosError<void>,
>(
  params?: ListPayablesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPayables>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPayablesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayables>>> = ({
    signal,
  }) => listPayables(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayables>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPayablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPayables>>
>;
export type ListPayablesQueryError = AxiosError<void>;

export function useListPayables<
  TData = Awaited<ReturnType<typeof listPayables>>,
  TError = AxiosError<void>,
>(
  params?: ListPayablesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPayables>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPayablesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getPayableStats = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutStatsDto>> => {
  return axios.default.get(`/api/payouts/payables/stats`, options);
};

export const getGetPayableStatsQueryKey = () => {
  return [`/api/payouts/payables/stats`] as const;
};

export const getGetPayableStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayableStats>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPayableStats>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayableStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayableStats>>> = ({
    signal,
  }) => getPayableStats({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayableStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayableStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayableStats>>
>;
export type GetPayableStatsQueryError = AxiosError<void>;

export function useGetPayableStats<
  TData = Awaited<ReturnType<typeof getPayableStats>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPayableStats>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayableStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_GET
 */
export const getPayableById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutDetailDto>> => {
  return axios.default.get(`/api/payouts/payables/${id}`, options);
};

export const getGetPayableByIdQueryKey = (id?: string) => {
  return [`/api/payouts/payables/${id}`] as const;
};

export const getGetPayableByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayableById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayableById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayableByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayableById>>> = ({
    signal,
  }) => getPayableById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayableById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayableByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayableById>>
>;
export type GetPayableByIdQueryError = AxiosError<void | ProblemDetails>;

export function useGetPayableById<
  TData = Awaited<ReturnType<typeof getPayableById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayableById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayableByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_GET
 */
export const getPayableByPayoutRequestId = (
  payoutRequestId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutDetailDto>> => {
  return axios.default.get(
    `/api/payouts/payables/by-payout-request/${payoutRequestId}`,
    options,
  );
};

export const getGetPayableByPayoutRequestIdQueryKey = (
  payoutRequestId?: string,
) => {
  return [
    `/api/payouts/payables/by-payout-request/${payoutRequestId}`,
  ] as const;
};

export const getGetPayableByPayoutRequestIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayableByPayoutRequestId>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  payoutRequestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayableByPayoutRequestId>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPayableByPayoutRequestIdQueryKey(payoutRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayableByPayoutRequestId>>
  > = ({ signal }) =>
    getPayableByPayoutRequestId(payoutRequestId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!payoutRequestId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayableByPayoutRequestId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayableByPayoutRequestIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayableByPayoutRequestId>>
>;
export type GetPayableByPayoutRequestIdQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetPayableByPayoutRequestId<
  TData = Awaited<ReturnType<typeof getPayableByPayoutRequestId>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  payoutRequestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayableByPayoutRequestId>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayableByPayoutRequestIdQueryOptions(
    payoutRequestId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYOUT_PAY_NOW
 */
export const payPayoutNow = (
  id: string,
  payPayoutNowDto: PayPayoutNowDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutDetailDto>> => {
  return axios.default.post(
    `/api/payouts/payables/${id}/pay-now`,
    payPayoutNowDto,
    options,
  );
};

export const getPayPayoutNowMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payPayoutNow>>,
    TError,
    { id: string; data: PayPayoutNowDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payPayoutNow>>,
  TError,
  { id: string; data: PayPayoutNowDto },
  TContext
> => {
  const mutationKey = ["payPayoutNow"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payPayoutNow>>,
    { id: string; data: PayPayoutNowDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return payPayoutNow(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayPayoutNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof payPayoutNow>>
>;
export type PayPayoutNowMutationBody = PayPayoutNowDto;
export type PayPayoutNowMutationError = AxiosError<ProblemDetails | void>;

export const usePayPayoutNow = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payPayoutNow>>,
    TError,
    { id: string; data: PayPayoutNowDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof payPayoutNow>>,
  TError,
  { id: string; data: PayPayoutNowDto },
  TContext
> => {
  const mutationOptions = getPayPayoutNowMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_PAY_NOW
 */
export const payPayoutsNow = (
  payPayoutsNowDto: PayPayoutsNowDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.post(
    `/api/payouts/payables/pay-now`,
    payPayoutsNowDto,
    options,
  );
};

export const getPayPayoutsNowMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payPayoutsNow>>,
    TError,
    { data: PayPayoutsNowDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payPayoutsNow>>,
  TError,
  { data: PayPayoutsNowDto },
  TContext
> => {
  const mutationKey = ["payPayoutsNow"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payPayoutsNow>>,
    { data: PayPayoutsNowDto }
  > = (props) => {
    const { data } = props ?? {};

    return payPayoutsNow(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayPayoutsNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof payPayoutsNow>>
>;
export type PayPayoutsNowMutationBody = PayPayoutsNowDto;
export type PayPayoutsNowMutationError = AxiosError<ProblemDetails | void>;

export const usePayPayoutsNow = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payPayoutsNow>>,
    TError,
    { data: PayPayoutsNowDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof payPayoutsNow>>,
  TError,
  { data: PayPayoutsNowDto },
  TContext
> => {
  const mutationOptions = getPayPayoutsNowMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_CREATE
 */
export const createPayout = (
  createPayoutDto: CreatePayoutDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutDetailDto>> => {
  return axios.default.post(`/api/payouts`, createPayoutDto, options);
};

export const getCreatePayoutMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayout>>,
    TError,
    { data: CreatePayoutDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayout>>,
  TError,
  { data: CreatePayoutDto },
  TContext
> => {
  const mutationKey = ["createPayout"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayout>>,
    { data: CreatePayoutDto }
  > = (props) => {
    const { data } = props ?? {};

    return createPayout(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayout>>
>;
export type CreatePayoutMutationBody = CreatePayoutDto;
export type CreatePayoutMutationError = AxiosError<ProblemDetails | void>;

export const useCreatePayout = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayout>>,
    TError,
    { data: CreatePayoutDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPayout>>,
  TError,
  { data: CreatePayoutDto },
  TContext
> => {
  const mutationOptions = getCreatePayoutMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_UPDATE
 */
export const retryPayout = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutDetailDto>> => {
  return axios.default.post(`/api/payouts/${id}/retry`, undefined, options);
};

export const getRetryPayoutMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryPayout>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryPayout>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["retryPayout"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryPayout>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return retryPayout(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryPayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryPayout>>
>;

export type RetryPayoutMutationError = AxiosError<ProblemDetails | void>;

export const useRetryPayout = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryPayout>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryPayout>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getRetryPayoutMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYOUT_VOID
 */
export const voidPayout = (
  id: string,
  voidPayoutDto: VoidPayoutDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayoutDetailDto>> => {
  return axios.default.post(`/api/payouts/${id}/void`, voidPayoutDto, options);
};

export const getVoidPayoutMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidPayout>>,
    TError,
    { id: string; data: VoidPayoutDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voidPayout>>,
  TError,
  { id: string; data: VoidPayoutDto },
  TContext
> => {
  const mutationKey = ["voidPayout"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voidPayout>>,
    { id: string; data: VoidPayoutDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return voidPayout(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoidPayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof voidPayout>>
>;
export type VoidPayoutMutationBody = VoidPayoutDto;
export type VoidPayoutMutationError = AxiosError<ProblemDetails | void>;

export const useVoidPayout = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidPayout>>,
    TError,
    { id: string; data: VoidPayoutDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof voidPayout>>,
  TError,
  { id: string; data: VoidPayoutDto },
  TContext
> => {
  const mutationOptions = getVoidPayoutMutationOptions(options);

  return useMutation(mutationOptions);
};
